import { FC } from "react"

import { TournamentReferralData } from "types/tournament.types"

import { ReferralRewardHistory } from "./ReferralRewardHistory"
import { ReferralSummaryCards } from "./ReferralSummaryCards"
import { TopReferrersTable } from "./TopReferrersTable"

interface TournamentReferralActivityProps {
  referralData: TournamentReferralData
}

export const TournamentReferralActivity: FC<TournamentReferralActivityProps> = ({ referralData }) => {
  const hasNoActivity = referralData.referrers.length === 0 && referralData.reward_history.length === 0

  return (
    <div className="bg-white dark:bg-[#0C0C1A] rounded-xl border border-[rgba(0,0,0,0.05)] dark:border-[rgba(255,255,255,0.1)] shadow-sm">
      <div className="p-6 border-b border-[rgba(0,0,0,0.05)] dark:border-[rgba(255,255,255,0.1)]">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Referral Activity</h3>
      </div>

      <ReferralSummaryCards summary={referralData.summary} />
      <TopReferrersTable referrers={referralData.referrers} />
      <ReferralRewardHistory rewards={referralData.reward_history} />

      {hasNoActivity && <div className="px-6 pb-6 text-center text-gray-500 dark:text-gray-400">No referral activity yet</div>}
    </div>
  )
}
